import * as React from 'react'
import AccordionGroup from '@mui/joy/AccordionGroup'
import Accordion, { accordionClasses } from '@mui/joy/Accordion'
import AccordionDetails from '@mui/joy/AccordionDetails'
import AccordionSummary, { accordionSummaryClasses } from '@mui/joy/AccordionSummary'

const accordionGroupStyle = {
  [`& .${accordionClasses.root}`]: {
    marginTop: '0',
    transition: '0.2s ease',
    borderRadius: '0',
    '& [aria-expanded="true"]': {
      boxShadow: 'none',
    },
    '& button': {
      fontFamily: 'MaisonNeue, sans-serif',
      backgroundColor: '#FAFAFA',
      color: '#333333',
    },
    '& button:not([aria-expanded="true"])': {
      transition: '0.2s ease',
    },
    '& button:hover': {
      backgroundColor: '#FAFAFA',
      color: '#333333',
    },
  },
  '& [aria-expanded="true"]': {
    boxShadow: 'none',
  },
  width: '100%',
}

const accordionSummaryStyle = {
  padding: '10px 16px',
  fontSize: '14px',
  fontWeight: 600,
  textTransform: 'none',
  color: '#333333',
  backgroundColor: '#FAFAFA',
  minHeight: '44px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  borderBottom: '0.5px solid #e0e0e0',
  [`& .${accordionSummaryClasses.button}`]: {
    padding: 'inherit',
  },
}

const accordionDetailsStyle = {
  backgroundColor: '#ffffff',
  padding: 0,
  '& .MuiAccordionDetails-content': {
    margin: 0,
    padding: 0,
  },
  '&.MuiAccordionDetails-root': {
    padding: 0,
  },
}

const detailRowStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  padding: '16px 20px',
  fontSize: '15px',
}

const labelStyle = {
  color: '#333333',
}

const valueStyle = {
  color: '#333333',
  fontWeight: 500,
}

const subtitleStyle = {
  fontSize: '12px',
  color: '#888888',
  fontWeight: 'normal',
  marginLeft: 'auto',
  marginRight: '10px',
}

export default function AccordionStylingExpansion({ items }) {
  const renderDetails = (details) => {
    if (Array.isArray(details)) {
      return details.map((row, idx) => (
        <div key={idx} style={detailRowStyle}>
          <span style={labelStyle}>{row.label}</span>
          <span style={valueStyle}>{row.value}</span>
        </div>
      ))
    }
    return details
  }

  return (
    <AccordionGroup sx={accordionGroupStyle} variant="plain">
      {items.map((item, index) => (
        <Accordion key={`${item.title ?? index}-${index}`} defaultExpanded={item.defaultExpanded || false}>
          <AccordionSummary sx={accordionSummaryStyle}>
            <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ fontSize: '14px', fontWeight: 'bold' }}>{item.title}</span>
              {item.subtitle && <span style={subtitleStyle}>{item.subtitle}</span>}
            </div>
          </AccordionSummary>
          <AccordionDetails sx={accordionDetailsStyle}>{renderDetails(item.details)}</AccordionDetails>
        </Accordion>
      ))}
    </AccordionGroup>
  )
}
